import { render, staticRenderFns } from "./concept.vue?vue&type=template&id=47f4b18b&scoped=true&lang=pug"
import script from "./concept.vue?vue&type=script&lang=js"
export * from "./concept.vue?vue&type=script&lang=js"
import style0 from "./concept.vue?vue&type=style&index=0&id=47f4b18b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f4b18b",
  null
  
)

export default component.exports